import type { ComponentProps } from 'react'
import { memo } from 'react'

/** @inheritdoc */
export const typedMemo: <T>(
  c: T,
  // @ts-expect-error memo ломает дженерики компонентов
  // Поэтому что получили в memo, то и возвращаем
  // expect-error нужен для того, чтобы не писать T extends ... и не усложнять типы пропсов
  // Подробнее https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087
  areEqual?: (one: ComponentProps<T>, other: ComponentProps<T>) => boolean,
) => T = memo
